import * as React from "react";
import {api} from "../../../api";
import {AsyncSelect} from "./AsyncSelect";


export class FederalConstituencyPicker extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    loadOptions = (inputValue: string, callback: any) => {
        const filters = this.props.filters;
        // TODO min length, limit results in API
        api.federalConstituency.getListAction({
            page: 0,
            search: inputValue,
            filters: filters,
        }).then((response) => {
            callback(response.map((item: any) => ({
                value: item['id'],
                label: (item['name'] ? item['name'] : '') + ' (' + item['code'] + '), ' + (item['state'] ? item['state']['name'] : ''),
                id: item['id'],
            })));
        });
    };

    render() {
        const {...rest} = this.props;

        return (
            <AsyncSelect
                multi={true}
                cacheOptions={true}
                loadOptions={this.loadOptions}
                placeholder="Search federal constituency ..."
                {...rest}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/FederalConstituencyPicker.tsx